/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import ObjectTypesService from 'cio/services/object-types';

interface Args {
  openRelationshipsModal: () => unknown;
}

export default class AddPeopleDropdown extends Component<Args> {
  @service auth!: AuthService;
  @service objectTypes!: ObjectTypesService;

  get hasNoAccessToAdd() {
    return !this.auth.hasPermission('journeys/people/create');
  }

  get addPeopleOptions() {
    return [
      {
        label: 'Import a CSV',
        link: {
          route: 'imports.new',
          query: {
            type: 'people',
          },
        },
      },
      {
        label: 'Add a Person',
        link: {
          route: 'people.new',
          query: {},
        },
      },
      ...(this.args.openRelationshipsModal != null &&
      this.objectTypes.canCreateRelationships &&
      this.objectTypes.objectCount > 0
        ? [
            {
              label: 'Add Relationships',
              action: this.args.openRelationshipsModal,
            },
          ]
        : []),
    ];
  }
}
